import { Avatar, Box, Typography } from "@mui/material"

export default function NewContactButton({...params}){

    let toggleModal = params.toggleModal
    let setInput = params.setInput
    let setIsNewContact = params.setIsNewContact

    function openBlankContactModal(){
        let blankInput = {
            name: '',
            email: '',
        }
        toggleModal()
        setIsNewContact(true)
        setInput({...blankInput})
    }

    return(
        <Box className={"nameEmailAvatarBox"} display={"flex"} flexDirection={"row"} alignItems={"center"} justifyContent={"center"} gap={"10px"} paddingBottom={'10px'} onClick={openBlankContactModal}>
            <Avatar sx={{ width: 40, height: 40, bgcolor: "primary.main", color: "#FFFFFF" }}>{'+'}</Avatar>
            <Box className="nameEmailBox" display="flex" flexDirection="column">
                <Typography fontSize="18px">{'Add Contact'}</Typography>
            </Box>
        </Box>
    )
}
